// components/OrderList.jsx
import React from 'react';
import OrderDetails from './OrderDetails.jsx';
import './OrderList.css';

const statusLabels = {
    new: 'Новый',
    accepted: 'Принят',
    shipped: 'Отправлен',
    completed: 'Завершён',
    cancelled: 'Отменён'
};

const statusClass = {
    new: 'status-new',
    accepted: 'status-accepted',
    shipped: 'status-shipped',
    completed: 'status-completed',
    cancelled: 'status-cancelled'
};

const OrderList = ({ orders, loading, canEdit, canDelete, onEdit, onDelete, onStatusChange }) => {
    const [selectedOrder, setSelectedOrder] = React.useState(null);
    const [showDetails, setShowDetails] = React.useState(false);

    const openDetails = (order) => {
        setSelectedOrder(order);
        setShowDetails(true);
    };

    if (loading) {
        return <div className="loading-spinner">Загрузка...</div>;
    }

    if (!orders.length) {
        return <div className="empty-list">Заказов не найдено</div>;
    }

    return (
        <>
            <div className="order-table-container">
                <table className="order-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Покупатель</th>
                            <th>Товаров</th>
                            <th>Сумма</th>
                            <th>Статус</th>
                            <th>Дата</th>
                            <th>Действия</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map(order => (
                            <tr key={order._id}>
                                <td>{order._id}</td>
                                <td>
                                    {order.user ? (
                                        <div>
                                            <div><strong>{order.user.fname || ''} {order.user.sname || ''}</strong></div>
                                            <div className="user-contact">{order.user.email || order.user.mobile}</div>
                                        </div>
                                    ) : 'Гость'}
                                </td>
                                <td>{order.positions?.length || 0}</td>
                                <td><strong>{order.totalPrice} ₽</strong></td>
                                <td>
                                    {canEdit ? (
                                        <select
                                            value={order.status}
                                            onChange={(e) => onStatusChange(order._id, e.target.value)}
                                            className={`status-select ${statusClass[order.status]}`}
                                        >
                                            {Object.entries(statusLabels).map(([val, label]) => (
                                                <option key={val} value={val}>{label}</option>
                                            ))}
                                        </select>
                                    ) : (
                                        <span className={`status-badge ${statusClass[order.status]}`}>
                                            {statusLabels[order.status]}
                                        </span>
                                    )}
                                </td>
                                <td>{new Date(order.createdAt).toLocaleString()}</td>
                                <td className="actions">
                                    <button className="btn-small" onClick={() => openDetails(order)}>Детали</button>
                                    {canEdit && (
                                        <button className="btn-small btn-edit" onClick={() => onEdit(order)}>Редактировать</button>
                                    )}
                                    {canDelete && (
                                        <button className="btn-small btn-delete" onClick={() => onDelete(order._id)}>Удалить</button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showDetails && selectedOrder && (
                <OrderDetails
                    order={selectedOrder}
                    onClose={() => setShowDetails(false)}
                />
            )}
        </>
    );
};

export default OrderList;